exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ai-product-list{display:flex;flex-wrap:wrap;justify-content:flex-start;width:1150px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/product_list/product-list.style.scss
// module id = 214
// module chunks = 0